module.exports = __webpack_public_path__ + "static/img/chart-pic8.803d3c58.png";